<template>
  <div class="text-center">
    <v-dialog v-model="dialog" max-width="500" persistent>
      <v-card>
        <v-card-title class="text-h5 blue darken-3 white--text">
          Selecciona La Institucion de Convenio
        </v-card-title>

        <v-card-text>
          <p class="text-center green--text mt-4">
            Antes de continuar debe seleccionar la Institucion de convenio, puede cambiar la seleccion en la parte
            superior:
          </p>
          <div>
            <v-select
              v-model="$store.state.convenio"
              :items="convenios"
              :loading="loading"
              item-text="nombre"
              item-value="id"
              label="Convenio"
              class="mt-1"
              style="min-width:150px"
              dense
              placeholder="Seleccione...."
              return-object
            ></v-select>

            <p class="text-center red--text">{{ msg }}</p>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="cerrar()">
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Clave ref="xclavecita"/>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import Clave from './AModalClaveChange.vue'

  export default {
    data() {
      return {
        loading: true,
        dialog: false,
        msg: '',
        convenios: [],
      };
    },
    components:{
      Clave
    },
    methods: {
      openmodal() {
        this.msg = '';
        this.dialog = true;
      },
      setUniversidades(conves) {
        //this.dialog = true;
        this.convenios = conves;
        this.loading = false;
      },
      async getConveniosUniversidades() {
        let vue = this;
        vue.loading = true;
        const sql = gql`query{ getInstituciones(estado:true){id,nombre,tipo,convenio,abreviatura} }`;
        this.$apollo.query({ query: sql }).then(({ data }) => {
          let conves = data.getInstituciones;
          conves = conves.filter(x=>{return x.convenio});
          this.convenios = conves;
          vue.loading = false;
        });
      },
      cerrar() {
        if (this.$store.state.convenio) {
          this.dialog = !this.dialog;
        } else {
          this.msg = 'Debes seleccionar una institucion';
        }
      },
    },
  };
</script>
